export default __webpack_public_path__ + "static/media/folderIcon.bfbb971a.svg";